import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import SvgIcon from "@mui/material/SvgIcon";
import Button from "@mui/material/Button";

import {setLookMoreInfoOpened} from "../../../../../actions/lookFunctions";
import {LOOK_FEATURE_CONTENT} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {Look3DIcon, LookAugmentRealityIcon} from "../../../../common/icons";
import COLOR_THEMES, {COLORS} from "../../../../../colorThemes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {getDbFeatureProperty} from "../../lookFunctions2";

const LookFeatureInfoButtons = (props) => {

  const {lookActiveFeature, setLookMoreInfoOpened, moreInfoOpened, moreInfoContent, activeTheme, lookActiveCategory} = props;

  if (!lookActiveFeature) {
    return null
  }

  const infoButtonClick = (contentType) => {
    Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContentSwitch + contentType
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContentSwitch + contentType
    );
    const moreInfoType = moreInfoOpened && (moreInfoContent === contentType) ? "" : lookActiveCategory ? "select" : "main";
    setLookMoreInfoOpened(moreInfoType, contentType);
  }

  const threeActive = moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.threeD);
  const threeColor = threeActive ? COLORS.white : COLOR_THEMES[activeTheme].primary;

  const augActive = moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.aug);
  const augColor = threeActive ? COLORS.white : COLOR_THEMES[activeTheme].primary;

  return (
    <div className="lk-info__buttons">
      <Button className={"look-button look-button--large" + (threeActive ? " look-button--primary" : " look-button--secondary")}
              disabled={!Array.isArray(lookActiveFeature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")])}
              startIcon={(
                <SvgIcon>
                  <Look3DIcon color={threeColor} />
                </SvgIcon>
              )}
              onClick={() => infoButtonClick(LOOK_FEATURE_CONTENT.threeD)}>
        {IS_PRODUCT_JOURNEY
          ? <FormattedMessage id="grohe.feature.info.3dButton"/>
          : <FormattedMessage id="look.feature.info.3dButton"/>}
      </Button>
      <Button className={"look-button look-button--large" + (augActive ? " look-button--primary" : " look-button--secondary")}
              disabled={!lookActiveFeature.dbFeature[getDbFeatureProperty("lixilQRCode")]}
              startIcon={(
                <SvgIcon>
                  <LookAugmentRealityIcon color={augColor} />
                </SvgIcon>
              )}
              onClick={() => infoButtonClick(LOOK_FEATURE_CONTENT.aug)}>
        {IS_PRODUCT_JOURNEY
          ? <FormattedMessage id="grohe.feature.info.augButton"/>
          : <FormattedMessage id="look.feature.info.augButton"/>}
      </Button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {moreInfoOpened, moreInfoContent, lookActiveCategory, lookActiveFeature} = store.lookState;
  const {activeTheme} = store.serverState;
  return {
    lookActiveCategory,
    moreInfoContent,
    moreInfoOpened,
    activeTheme,
    lookActiveFeature,
  };
};

const mapDispatchToProps = {
  setLookMoreInfoOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureInfoButtons)
)
